var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"col-md-3 sidebar sidebar-right p-md-3 d-flex flex-column"},[_c('div',{staticClass:"sub-title"},[_vm._v("Offerteoverzicht")]),_c('app-materials',{on:{"openSawingSchedule":_vm.openSawingSchedule}}),_c('app-sawing-schedule',{ref:"appSawingSchedule"}),_c('app-summary')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }